import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact" id="contact">
      <h2 className="font-heading pt-5 mt-5 text-center">
        <span className="about-title ">Contact</span>
      </h2>
      <div className="container mt-5 pb-5 pt-3">
        <div className="row">
          <div className="col font text-center">
            <h3>Just say Hi.</h3>
            <p>
              I am always open to discuss new project and talk about new
              technologies.
            </p>
            <div>
              <div>
                <p className="email">You can mail me at</p>
                <p className="email">
                  <a href="mailto:mariamchowdhury.200@gmail.com">
                    mariamchowdhury@gmail.com
                  </a>
                </p>
                <p className="my-4">Follow me at</p>
                <div className="social-media">
                  <a
                    href="https://www.linkedin.com/in/mariam-chowdhury/"
                    target="_blank"
                  >
                    <i class="fab fa-linkedin"></i>
                  </a>
                  <a href="https://github.com/MariamChowdhury" target="_blank">
                    <i class="fab fa-github"></i>
                  </a>

                  <a
                    href="https://www.instagram.com/mint___lemon___ade/"
                    target="_blank"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/profile.php?id=100015189241148"
                    target="_blank"
                  >
                    <i class="fab fa-facebook"></i>
                  </a>
                  <a href="https://mariamchowdhury.medium.com/" target="_blank">
                    <i class="fab fa-medium"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
